<template>
  <div class="item">
    <div class="item_wrap" @click="detail(item.id, item.category)">
      <div class="is-clearfix">
        <div class="name">{{ $t(`docflow.fullDocTypes.${item.category}`) }} &laquo;{{ item.registration_number }}&raquo;</div>
        <b-tag :type="`is-primary`" class="ml-5">
          {{ $t(`workflow.states.${item.state}`) }}
        </b-tag>
        <div class="is-pulled-right type">{{ item.type__name }}</div>
      </div>
      <div class="description">{{ item.description }}</div>
      <div class="is-clearfix mt-3">
        <div class="maintainer">{{ item.organization__name }}</div>
        <div class="term">{{ item.term_date | localedDate }}</div>
      </div>
    </div>
    <br>
    <RelatedDocumentsControl v-for="data in item.children" :v-key="data.id" :item="data"></RelatedDocumentsControl>
  </div>
</template>

<script>
  import RelatedDocumentsControl from '@/components/RelatedDocumentsControl'

  export default {
    name: 'RelatedDocumentsControl',
    props: ['item'],
    comments: {RelatedDocumentsControl},
    methods: {
      detail(id, category) {
        let detailRoutes = {
          outgoing: 'docflowOutgoingDetail',
          incoming: 'docflowIncomingDetail',
          appeal: 'docflowAppealDetail'
        }
        this.$router.push({
          name: detailRoutes[category],
          params: {documentId: id}
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

  .item > .item {
    padding-left: 35px;
    position: relative;
    &:before {
      display: block;
      content: '';
      width: 25px;
      height: 22px;
      background: url("../assets/planItemTree.svg");
      position: absolute;
      left: 2px;
      top: -5px;
    }
  }

  .item_wrap {
    margin-bottom: 10px;
    display: inline-block;
    min-width: 350px;
    background: #f6f6f6;
    padding: 7px 14px;
    border-radius: 6px;
    cursor: pointer;

    .name {
      font-size: 16px;
      font-weight: 500;
      display: inline-block;
    }

    .type {
      font-size: 12px;
      line-height: 26px;
      margin-left: 40px;
    }

    .description {
      font-size: 12px;
      color: #8a8a8a;
      display: block;
    }

    .maintainer {
      font-size: 12px;
      float: left;
    }

    .term {
      font-size: 12px;
      float: right;
      margin-left: 40px;
    }
  }
</style>